<div class="container">
  <app-login-action />
</div>
<div class="top-right-toast-container">
  <div *ngFor="let toast of toastService.toasts">
    <ngb-toast [class]="toast.classname"
               [autohide]="toast.autoClose !== false"
               [delay]="toast.autoClose !== false ? toast.delay || 5000 : 999999999"
               (hidden)="toastService.remove(toast.id)"
               [header]="toast.header">
      {{toast.body}}
      <button *ngIf="toast.action" class="btn btn-primary float-right"
              (click)="toast.action.callback()">
        {{toast.action.label}}
      </button>
    </ngb-toast>
  </div>
</div>

<div class="app-container">
  <router-outlet></router-outlet>
</div>
